import { gql } from "@apollo/client";

export const holdKavaDecision = gql`
  mutation HoldKavaDecision($input: HoldKavaDecision!) {
    holdKavaDecision(input: $input)
  }
`;
